<button style="pointer-events: all;" class="btn-right" *ngIf="visible" [class.btn-right-clicked]="clicked" (click)="buttonClicked()">
  <i class="fa"
  [ngClass]="clicked && clickedClass? clickedClass : unclickedClass"
   aria-hidden="true"></i>
</button>